(function () {
    'use strict';

    angular
        .module('gov.directives')
        .directive('govPager', govPager);

    govPager.$inject = ['$rootScope'];

    function govPager() {
        return {
            restrict: 'E',
            scope: {
                pager: '=pagerobj',
                pagerLabels: '=?'
            },
            replace: true,
            templateUrl: function(element, attrs) {
                if (attrs.template) {
                    return '/app/shared/components/directives/govPager.directive.' + attrs.template + '.html';
                }
                return '/app/shared/components/directives/govPager.directive.html';
            },
            link: function (scope, element, attrs) {
            }
        };
    }

})();